// @flow
import * as React from 'react';
import Radium from 'radium';

import { Card, CardHeader, CardBlock } from 'reactstrap';

type Props = {
  street: string,
  zip: string,
  city: string,
};

const API_KEY = 'AIzaSyC3EPp_CZU-VREd6FLh1oPluWWSiphvF98';

class Map extends React.Component<Props> {
  render() {
    const { street, zip, city } = this.props;
    const address = `${street}, ${zip} ${city}`;
    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Auf der Karte</CardHeader>
        <CardBlock>
          <iframe
            width="100%"
            height="350"
            src={`https://www.google.com/maps/embed/v1/place?q=${address}&key=${API_KEY}`}
            frameBorder="0"
          />
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

export default Radium(Map);



// WEBPACK FOOTER //
// ./src/components/Map/Map.js